define(["github:guardian/iframe-messenger@master/src/iframeMessenger.js"], function(main) {
  return main;
});